import styled from 'styled-components/macro';
// import { breakpointsRefresh as breakpoints } from 'common/styles';

export const Hint = styled.div`
  font-size: var(--font-size-xs);
  margin-top: 0.5rem;
  color: var(--color-text);
  opacity: 0;
`;

export const RichEditorContainer = styled.div`
  display: contents;

  &:focus-within ${Hint} {
    opacity: 1;
  }
`;

export const EditorWrapper = styled.div`
  .tiptap.ProseMirror {
    border-radius: var(--border-radius-xs);
    border: 1px solid transparent;
    padding: 0.25rem 0.5rem;
    margin-left: -0.5rem;

    outline: none;

    &:hover {
      background-color: var(--color-input-hover);
    }

    &:focus,
    &.ck-focused {
      border: 1px solid var(--color-primary);
      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1) inset, 0 0; // From old CKEditor
    }

    p {
      color: var(--color-input-text);
      font-size: var(--font-size-sm);
      line-height: 1.5;
      max-width: 90ch;
      margin: 0;

      & + p {
        margin-top: 0.75rem;
      }

      &:before {
        color: var(--color-input-placeholder);
      }
    }

    .suggestion {
      color: var(--color-primary);
    }

    .mention {
      padding: 3px;
      margin: -3px;
      border-radius: var(--border-radius-sm);
      background: var(--color-primary-lightest);
      color: var(--color-primary-dark);

      &.user-mention {
        background: var(--color-user-mention);
      }
    }

    p.is-editor-empty:first-child::before {
      content: attr(data-placeholder);
      float: left;
      color: var(--color-text);
      pointer-events: none;
      height: 0;
    }
  }
`;

export const BubbleMenuContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.2rem;

  background: var(--color-background);
  box-shadow: var(--shadow-md);

  border: 1px solid var(--color-grey-lightest);
  border-radius: var(--border-radius-lg);

  > label {
    margin: 0;
    font-size: var(--font-size-sm);
  }
`;

export const MentionPopup = styled.div`
  position: absolute;
  top: ${({ position }) => position.top}px;
  left: ${({ position }) => position.left}px;
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-lg);
  background: var(--color-modal);
  border: 1px solid var(--color-text-lightest);
  box-shadow: var(--shadow-md);
  padding: 0.5rem;
  z-index: 999999 !important;
  font-size: var(--font-size-sm);
  min-width: 10rem;
  color: var(--color-text-darkest);
  white-space: nowrap;
`;

export const MentionWrapper = styled.div`
  padding: 0.5rem;
  border: 1px solid transparent;
  border-radius: var(--border-radius-xs);
  cursor: pointer;

  background-color: ${({ active }) => active && 'var(--color-primary)'};
  color: ${({ active }) => active && 'var(--color-text-lightest)'};

  outline: none;
`;
